import Input from "@/components/Usados/InputField";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import Alert from "@/components/ui/alert/Alert";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Autocomplete from "@/components/Usados/AutoComplete";
import DatePicker from "@/components/Usados/date-picker";
import { apiFetch } from "@/service/api";

export default function CreateProyecto() {
  const navigate = useNavigate();
  const initialFormState = {
    nombre: "",
    descripcion: "",
    tipo_proyecto_id: "",
    estado_proyecto_id: "",
    fecha_inicio: "",
    fecha_entrega_estimada: "",
    presupuesto: "",
  };

  const [form, setForm] = useState(initialFormState);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [tipos, setTipos] = useState<any[]>([]);
  const [estados, setEstados] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resTipos, resEstados] = await Promise.all([
          apiFetch(`json/tipo_proyecto`),
          apiFetch(`json/estado_proyecto`),
        ]);
        if (resTipos.ok) {
          const data = await resTipos.json();
          setTipos(data.map((e: any) => ({ value: e.id, label: e.nombre })));
        }
        if (resEstados.ok) {
          const data = await resEstados.json();
          setEstados(data.map((e: any) => ({ value: e.id, label: e.nombre })));
        }
      } catch (error) {
        console.error("Error fetching project data:", error);
      }
    };
    fetchData();
  }, []);

  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const payload = {
      ...form,
      tipo_proyecto_id: Number(form.tipo_proyecto_id),
      estado_proyecto_id: Number(form.estado_proyecto_id),
      presupuesto: Number(form.presupuesto),
    };
    try {
      const response = await apiFetch(`proyectos/create`, {
        method: "POST",
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al crear proyecto");
      }
      const data: any = await response.json();
      setSuccess(true);
      setTimeout(
        () => navigate(`/gestion_proyectos/proyectos/update/${data.id}`),
        200,
      );
    } catch (err: any) {
      setError(err.message);
    }
  }

  return (
    <div>
      <div className="min-h- rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <h3 className="mb-8 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
          Crear Proyecto
        </h3>
        {error && <Alert variant="error" title="Error" message={error} />}
        {success && (
          <Alert
            variant="success"
            title="exito"
            message="Proyecto creado correctamente"
          />
        )}
        <form onSubmit={handleSubmit} className="space-y-6 max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="col-span-2">
              <Label>Nombre del Proyecto</Label>
              <Input
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                required
                placeholder="Ej: Rediseño Web"
              />
            </div>
            <div className="col-span-2">
              <Label>Descripcion</Label>
              <textarea
                name="descripcion"
                value={form.descripcion}
                onChange={handleChange}
                className="w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2 text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:text-white/90"
                rows={3}
                required
              />
            </div>
            <div>
              <Autocomplete
                label="Seleccionar tipo"
                options={tipos}
                value={form.tipo_proyecto_id}
                onChange={(id) => setForm({ ...form, tipo_proyecto_id: id })}
                placeholder="Seleccione un tipo"
              />
            </div>
            <div>
              <Autocomplete
                label="Seleccionar estado"
                options={estados}
                value={form.estado_proyecto_id}
                onChange={(id) => setForm({ ...form, estado_proyecto_id: id })}
                placeholder="Seleccione un estado"
              />
            </div>
            <div>
              <Label>Fecha de Inicio</Label>
              <DatePicker
                id="fecha_nacimiento"
                placeholder="Selecciona una fecha"
                defaultDate={form.fecha_inicio}
                onChange={(selectedDates) =>
                  setForm({
                    ...form,
                    fecha_inicio: selectedDates[0].toISOString().split("T")[0],
                  })
                }
              />
            </div>
            <div>
              <Label>Fecha Entrega Estimada</Label>
              <DatePicker
                id="fecha_entrega_estimada"
                placeholder="Selecciona una fecha"
                defaultDate={form.fecha_entrega_estimada}
                onChange={(selectedDates) =>
                  setForm({
                    ...form,
                    fecha_entrega_estimada: selectedDates[0]
                      .toISOString()
                      .split("T")[0],
                  })
                }
              />
            </div>
            <div className="col-span-2">
              <Label>Presupuesto</Label>
              <Input
                type="number"
                name="presupuesto"
                value={form.presupuesto}
                onChange={handleChange}
                required
                placeholder="0.00"
              />
            </div>
          </div>
          <div className="flex justify-end gap-4 mt-8">
            <Button
              variant="outline"
              onClick={() => navigate("/gestion_proyectos/proyectos")}
              type="button"
            >
              Cancelar
            </Button>
            <Button type="submit">Crear Proyecto</Button>
          </div>
        </form>
      </div>
    </div>
  );
}
